import React, { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Router } from '../../router/Router';
import { NumberSlider } from '../../components/NumberSlider';
import { Store } from '../../models/StoresResponse';
import { checkStore } from '../../helpers/CheckStore';
import { formatByTemplate } from '../../helpers/date';
import { User } from '../../models/User';
import { API } from '../../utils/API';
import { Loading } from '../../components/Loading';
import { CSDProvider } from '../../components/CSDProvider';

export const CustomerConfirmation: FC = () => {
  const router = Router(useNavigate());

  const [selectedStore] = useState<Store>(checkStore());
  const [user, setUser] = useState<User>();
  const [isLoading, setLoading] = useState<boolean>(false);

  const handleCancel = () => router.goToRepresentativeConfirmation();

  const checkSelectedStore = () => {
    if (selectedStore === undefined) {
      router.goToStore();
      return;
    }
    const retrievedUser = localStorage.getItem('user');
    if (retrievedUser !== null) {
      setUser(JSON.parse(retrievedUser));
    }
  };

  const handleWithdrawal = async () => {
    if (user) {
      try {
        return await API.CSD.withdrawal(selectedStore.id, selectedStore.store_tablet_id, user.key);
      } catch (error) {
        console.error(error);
        setLoading(false);
        return error;
      }
    }
  };

  const handleConfirm = () => {
    setLoading(true);
    handleWithdrawal()
      .then((response) => {
        console.log(response);
        setLoading(false);
        if (response.withdrawal_cash_id === undefined) {
          router.goToCashOutResult(true, response.message);
          return;
        }
        router.goToCashOutResult(false, '');
      });
  };

  useEffect(() => {
    checkSelectedStore();
  }, []);

  return (
    <CSDProvider>
      <div className="container-fluid-background">
        <div className="row Navbar">
          <div className="col my-auto">
            <p className="my-auto" style={{ color: 'white' }}>
              <span style={{ fontWeight: 'bold' }}>OLYNS</span> - {`${selectedStore?.company} ${selectedStore?.name}`.toUpperCase()}
            </p>
          </div>
          <div className="col my-auto text-center">
            <p className="my-auto" style={{ color: 'white', fontWeight: 'bold' }}>GET CASH</p>
          </div>
          <div className="col my-auto text-end">
            <p className="my-auto" style={{ color: 'white' }}>{formatByTemplate(new Date(), 'hh:mmA, MMMM DD').toUpperCase()}</p>
          </div>
        </div>

        <div className="row" style={{ height: '90vh', display: 'flex', alignItems: 'center' }}>
          <div className="col text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <NumberSlider slide={3} />

            <div className="WhiteContainerNoPadding">
              <div className="GradientBG">
                <span>HI {user?.first_name.toUpperCase()}!</span>
                <br />
                <span>CONFIRM YOU RECEIVED</span>
              </div>
              <p className="Balance">${user?.balance.toFixed(2)}</p>
            </div>

            <button type="button" className="btn GreenLightConfirmButton" onClick={handleConfirm}>Confirm</button>
            <button type="button" className="btn CancelButton" onClick={handleCancel}>Cancel</button>
          </div>
        </div>
      </div>
      <Loading isVisible={isLoading} />
    </CSDProvider>
  );
};
